export default __webpack_public_path__ + "static/transaction-components-v3-ac0a354d0e43a3fa03ba0bac2c84c94b.png";